{
  "contact-details": {
    "email": "Email address",
    "mobilePhone": "Mobile phone",
    "nextLabel": "$t(common:next): <b>Your GP (doctor)</b>",
    "otherPhone": "Other phone",
    "text": "We’ve been using these details to contact you, but you can update if needed.",
    "title": "Your contact details"
  },
  "doctor": {
    "gp": "GP (doctor) name",
    "manually": "Doctor not showing? <PrimaryText>Enter it manually...</PrimaryText>",
    "medicalCentre": "Medical Centre",
    "nextLabel": "$t(common:next): <b>Your emergency contact</b>",
    "searchPlaceholder": "Search for your GP or medical centre",
    "text": "Is this your GP? If not, please update.",
    "title": "Your GP (doctor)"
  },
  "emergency": {
    "fullName": "Full name",
    "mobileNumber": "Mobile number",
    "nextLabel": "$t(common:next): <b>Insurance / who’s paying</b>",
    "relationship": "Relationship to you",
    "select": {
      "child": "Child",
      "friend": "Friend",
      "other": "Other",
      "parent": "Parent",
      "spouse": "Spouse / Partner"
    },
    "text": "Who should we contact in an emergency?",
    "title": "Your emergency contact",
    "footnote": "Please ensure this person knows you are having a procedure and can be contacted on the day, if required."
  },
  "home-address": {
    "building": "Building or Subdivision level, floor or unit",
    "city": "Town/City",
    "manually": "Address not showing? <PrimaryText>Enter it manually...</PrimaryText>",
    "nextLabel": "$t(common:next): <b>Your contact details</b>",
    "postcode": "Postcode",
    "searchPlaceholder": "Search address in New Zealand",
    "street": "Street name and number",
    "suburb": "Suburb or RD",
    "text": "Please enter your home address:",
    "textSecondary": "Here’s the address we’ll use:",
    "title": "Your home address"
  },
  "name-birthdate": {
    "birthDate": "Date of birth",
    "dateFormat": "dd/mm/yyyy",
    "familyName": "FAMILY name:",
    "firstName": "First name(s)",
    "nextLabel": "$t(common:next): <b>Your residency status</b>",
    "preferredName": "Preferred name",
    "select": {
      "dame": "Dame",
      "dr": "Dr",
      "label": "Title",
      "miss": "Miss",
      "mr": "Mr",
      "mrs": "Mrs",
      "ms": "Ms",
      "mx": "Mx",
      "placeholder": "Select your title",
      "prof": "Prof",
      "rev": "Rev",
      "sir": "Sir"
    },
    "text": "Please check these details and update anything that’s missing or incorrect:",
    "title": "Your name and birthdate"
  },
  "nhi-residency": {
    "nextLabel": "$t(common:next): <b>Your home address</b>",
    "nhiNumber": "NHI number",
    "resident": "Are you a New Zealand resident?",
    "residentText": "If you’re not a NZ resident, you may be billed for some services such as lab tests.",
    "text": "Are you a New Zealand resident?",
    "title": "Your residency status"
  }
}
